import React from 'react';
import Platform from './Platform';

interface Props {
  fields: any;
}

const Platforms = ({ fields }: Props) => {
  return fields.map((field: any, index: number) => {
    const platform = fields.get(index);
    return <Platform key={index} platform={platform} field={field} />;
  });
};

export default Platforms;
